module.exports = __webpack_public_path__ + "img/c3.8f89e55a.png";